import { render } from "./App.vue?vue&type=template&id=8e1964d2"
const script = {}

import "./App.vue?vue&type=style&index=0&id=8e1964d2&lang=css"

import exportComponent from "/var/www/vhosts/drk-hurricane.de/test-helfer.drk-hurricane.de/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__